import React, { FC, useRef, useState } from "react";
import clsx from "clsx";
import { Link, makeStyles } from "@material-ui/core";
import { ReactComponent as Email } from "../../../../assets/svg/email-open-state.svg";
import WeduTooltip from "../../../../components/WeduTooltip/intex";
import { ReactComponent as WhatsApp } from "../../../../assets/svg/whats-app.svg";
import { ReactComponent as Viber } from "../../../../assets/svg/viber.svg";
import FontIcon from "../../../../components/FontIcon";

const useStyles = makeStyles(() => ({
  mainContainer: {
    border: "1px solid #DBDBDB",
    borderRadius: 5,
    padding: 8,
    display: "grid",
    gridTemplateColumns: "110px 200px",
    columnGap: "6px",
    rowGap: "12px",
    marginBottom: 14,
  },
  contactIconContainer: {
    display: "flex",
    alignItems: "center",
  },
  title: {
    fontSize: 16,
    color: "#231F20",
    marginLeft: 8,
  },
  linkCopyIconContainer: {
    "&:hover": {
      "& span": {
        fontSize: 9,
        marginLeft: 4,
        opacity: 1,
        transition: "opacity 0.3s, margin-left 0.3s",
      },
    },
  },
  link: {
    fontSize: 14,
    color: "#127DB3",
    marginLeft: 8,
  },
  copyIcon: {
    fontSize: 9,
    marginLeft: -4,
    color: "#858997",
    cursor: "pointer",
    opacity: 0,
    transition: "opacity 0.3s, margin-left 0.3s",
  },
  successColor: {
    color: "green",
  },
}));

enum CopyText {
  "Copied" = "Copied!",
  "Clipboard" = "Copy to clipboard",
}

const initialState = {
  email: CopyText.Clipboard,
  whatsApp: CopyText.Clipboard,
  viber: CopyText.Clipboard,
};

const ContactForm: FC = () => {
  const classes = useStyles();
  const [copyTooltipsState, setCopyTooltipsState] = useState(initialState);
  const timeoutIdRef: any = useRef(0);

  const { email, whatsApp, viber } = copyTooltipsState;

  const copyHandler = (value, name) => {
    navigator.clipboard.writeText(value).then(() => {
      setCopyTooltipsState({
        ...initialState,
        [name]: CopyText.Copied,
      });
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = setTimeout(
        () => setCopyTooltipsState(initialState),
        3000,
      );
    });
  };

  return (
    <div className={classes.mainContainer}>
      <div className={classes.contactIconContainer}>
        <Email />
        <div className={classes.title}>Email</div>
      </div>
      <div className={classes.linkCopyIconContainer}>
        <Link
          className={classes.link}
          href={"mailto:support@worlded.us"}
          underline="none"
        >
          support@worlded.us
        </Link>
        <WeduTooltip title={email}>
          <FontIcon
            name={email === CopyText.Copied ? "feature" : "copy"}
            className={clsx(
              classes.copyIcon,
              email === CopyText.Copied && classes.successColor,
            )}
            onMouseUp={() => copyHandler("support@worlded.us", "email")}
          />
        </WeduTooltip>
      </div>
      <div className={classes.contactIconContainer}>
        <WhatsApp />
        <div className={classes.title}>WhatsApp</div>
      </div>
      <div className={classes.linkCopyIconContainer}>
        <Link
          className={classes.link}
          href={"whatsapp://send?phone=19547400321"}
          underline="none"
        >
          +1 954 7400321
        </Link>
        <WeduTooltip title={whatsApp}>
          <FontIcon
            name={whatsApp === CopyText.Copied ? "feature" : "copy"}
            className={clsx(
              classes.copyIcon,
              whatsApp === CopyText.Copied && classes.successColor,
            )}
            onMouseUp={() => copyHandler("+19547400321", "whatsApp")}
          />
        </WeduTooltip>
      </div>
      <div className={classes.contactIconContainer}>
        <Viber />
        <div className={classes.title}>Viber</div>
      </div>
      <div className={classes.linkCopyIconContainer}>
        <Link
          className={classes.link}
          href={"viber://chat?number=%2B19547400321"}
          underline="none"
        >
          +1 954 7400321
        </Link>
        <WeduTooltip title={viber}>
          <FontIcon
            name={viber === CopyText.Copied ? "feature" : "copy"}
            className={clsx(
              classes.copyIcon,
              viber === CopyText.Copied && classes.successColor,
            )}
            onMouseUp={() => copyHandler("+19547400321", "viber")}
          />
        </WeduTooltip>
      </div>
    </div>
  );
};

export default ContactForm;
